// extracted by mini-css-extract-plugin
export default {"partnership":"Partnership_partnership__NtiT0","textPart":"Partnership_textPart__W9CxU","formPart":"Partnership_formPart__wBUMu"};